import axios, {
  AxiosInstance,
  Method
}                    from 'axios';
import noVideoSrc    from '../../assets/images/camera-offline.png';
import { tokenType } from '../../store/API/types';
import {
  onImageLoadError,
  onImageLoadSuccess
}                    from "../../utils";
import { xmlToJson } from '../../utils/parserXML';
import {
  AsyncResponseType,
  BrowseFrameHTMLElement,
  doImageUpdateInterface,
  loginType
}                    from '../types';
import {
  browseGoToInterface,
  browseMoveInterface,
  CayugaResponseType,
  CayugaServiceDataInterface,
  createCayugaBookmarkType,
  getTimeLineInterface,
  IAlarm,
  IAlarmScenarios,
  IBasicResponse,
  IButtonScenarios,
  ICheckError,
  IEntityTree,
  IErrorResponse,
  IJpegImage,
  IRequestArchiveRanges,
  IRequestBkmList,
  IRequestCameraList,
  IRequestDetailedCameraList,
  IRequestLayerInfo,
  IRequestMapInfo,
  IRequestWebPageInfo,
  ITriggeredAlarms,
  playBackInterface
} from './types';

const {CONFIG} = window;

// TODO
// rewrite token to interceptors instead of passing to request

export class CayugaServiceData implements CayugaServiceDataInterface {
  playback: playBackInterface;

  constructor() {
    this.browseGoto = this.browseGoto.bind(this);
    this.doImageUpdate = this.doImageUpdate.bind(this);

    this.playback = {
      goto: this.browseGoto.bind(this),
      next: this.browseMoveStep.bind(this),
      prev: this.browseMoveStep.bind(this)
    }
  }


  cancelTokens: any = {};
  tokens: string[] = [];
  TOKEN: tokenType = '';
  baseUrl: string = `https://${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort}/SeeTecGatewayService/GatewayServiceRest`;
  instance: AxiosInstance = axios.create({
    baseURL: this.baseUrl,
    timeout: 60000
  });

  fetchUrl = async (url: string, method: Method = 'get', requestId?: string) => {
    const cancelToken = axios.CancelToken.source();
    if (requestId) this.cancelTokens[requestId] = cancelToken;

    try {
      const response = await this.instance.request({
        method: method,
        url: url,
        cancelToken: cancelToken.token,
      });

      const xmlString: string = response.data;
      const XmlNode = new DOMParser().parseFromString(xmlString, 'text/xml');
      return xmlToJson(XmlNode);
    } catch (err) {
      if (axios.isCancel(err)) {
        // console.log('Error: ', err.message); // => prints: Api is being canceled
      }
      return {error: true, data: err};
    }
  };

  getData = async <T>(url: string, method: Method = 'get', cancelId?: string): AsyncResponseType<T | IErrorResponse> => {
    const data: any = await this.fetchUrl(url, method, cancelId);
    if (data.error) {
      return {
        'a:ErrorCode': '-1',
        'a:ErrorDescription': `${data.data}`
      };
    }
    const urlPart = url.substr(1, url.indexOf('?') - 1);
    let responseKey = `${urlPart}Response`;
    let resultKey = `${urlPart}Result`;
    if (data) {
      return data[responseKey][resultKey];
    } else {
      return {
        'a:ErrorCode': '-1',
        'a:ErrorDescription': `${urlPart} request fetch error`
      };
    }

  }

  // ************* playback video ***************

  fetchImageUrl = async <T>(url: string, id: string): AsyncResponseType<string | void> => {
    const elem = document.getElementById(id) as BrowseFrameHTMLElement;

    try {
      const result = this.checkError<IJpegImage>(await this.getData<IJpegImage>(url), null);
      const {data} = result;
      if (!result.error && data["a:Camera"]["a:EntityID"] !== '-1') {
        const newTimestamp = (() => {
          if (url.indexOf('FORWARD') > 0) {
            return parseInt(data["a:Timestamp"]) + 1;
          } else if (url.indexOf('BACKWARD') > 0) {
            return parseInt(data["a:Timestamp"]) - 1;
          } else {
            return parseInt(data["a:Timestamp"]);
          }
        })().toString();
        elem.browseFrame = {
          startTime: newTimestamp,
          endTime: newTimestamp,
          nextTime: newTimestamp,
          receiveTime: newTimestamp,
          responseTime: newTimestamp,
          cameraLabel: data?.["a:Camera"]?.["a:Name"]
        };
      } else {
        throw new Error(data["a:ErrorDescription"]);
      }
      return data?.["a:Camera"]?.["a:Thumbnail"]
    } catch (e) {
      console.log(e);
    }


  };

  doImageUpdate = async (params: doImageUpdateInterface): Promise<void> => {
    const {id, fetchFunc, cb, pane} = params;
    const elem = document.getElementById(id) as BrowseFrameHTMLElement;

    if (elem && !elem.blocked) {
      elem.blocked = true;
      try {
        const blob = await fetchFunc();
        if (blob) {
          elem.src = 'data:image/jpeg;base64,' + blob;
          elem.onload = () => {
            elem.style.opacity = '1';
            onImageLoadSuccess(elem, cb, pane);
          };
          elem.onerror = () => {
            onImageLoadError(elem, cb, noVideoSrc, pane);
          }
        } else {
          throw new Error(blob);
        }
      } catch (err) {
        onImageLoadError(elem, cb, noVideoSrc, pane);
      }
    }
  };

  browseMoveStep(params: browseMoveInterface): void {
    const {token, camId, id, width, time, dir, pane, cb} = params;
    let dirText: 'FORWARD' | 'BACKWARD' = 'FORWARD';
    if (dir === 1) {
      dirText = 'FORWARD';
    } else if (dir === -1) {
      dirText = 'BACKWARD';
    }
    const url = `/Request_Archive_JPEG_Stepwise?sessionID=${token}&cameraEntityID=${camId}&imageWidth=${width}&timestamp=${time}&direction=${dirText}`;
    const fetchFunc = () => this.fetchImageUrl<IJpegImage>(url, id);
    this.doImageUpdate({id, fetchFunc, cb, pane});
  }

  browseGoto(params: browseGoToInterface): void {
    const {token, time, pane, width, camId, id} = params;
    const url = `/Request_Archive_JPEG?sessionID=${token}&cameraEntityID=${camId}&imageWidth=${width}&timestamp=${time}`;
    const fetchFunc = () => this.fetchImageUrl<IJpegImage>(url, id);
    const cb = () => {
    };
    this.doImageUpdate({id, fetchFunc, cb, pane});
  };

  login = async ({username, password, cancelId}: loginType): CayugaResponseType<string> => {
    const headers = {
      username: '',
      password: ''
    };
    try {
       headers.username = btoa(username);
       headers.password = btoa(password);
    } catch (e) {
      throw new Error('Please check your username and password and try again');
    }

    const uri = `/Connect?userName=${headers.username}&password=${headers.password}&type=2`;

    const data: any = await this.getData(uri, 'get', cancelId);

    const checkRes = this.checkError<string>(data, 'a:SessionID');
    if (!checkRes.error) {
      this.TOKEN = checkRes.data;
    }
    return checkRes;
  };

  checkConnection = async (token: tokenType): CayugaResponseType<string> => {
    const url = `/Ping?sessionID=${token}`;
    const res = await this.getData(url);
    return this.checkError(res, 'a:ErrorDescription');
  };

  getCameraList = async (token: tokenType): CayugaResponseType<IRequestCameraList> => {
    const url = `/Request_Camera_List?sessionID=${token}`
    const res = await this.getData<IRequestCameraList>(url);
    debugger;
    return this.checkError(res, 'a:Entity');
  }

  getDetailedCameraList = async (token: tokenType): CayugaResponseType<IRequestDetailedCameraList> => {
    const url = `/Request_Detailed_Camera_List?sessionID=${token}`
    const res: any = await this.getData<IRequestDetailedCameraList>(url);
    return this.checkError(res, 'a:Entities');
  }

  requestEntityTree = async (token: tokenType): CayugaResponseType<IEntityTree> => {
    const url = `/Request_Entity_Tree?sessionID=${token}`
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:Entities');
  }

  requestLayerInfo = async (token: tokenType, layerId: string): CayugaResponseType<IRequestLayerInfo> => {
    const url = `/Request_Layer_Info?sessionID=${token}&layerEntityID=${layerId}`
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:GridElements');
  }
  requestMapInfo = async (token: tokenType, mapId: string): CayugaResponseType<IRequestMapInfo> => {
    const url = `/Request_Map_Info?sessionID=${token}&mapEntityID=${mapId}`
    const res: any = await this.getData(url);
    return this.checkError(res, null);
  }
  requestWebPageInfo = async (token: tokenType, webPageId: string): CayugaResponseType<IRequestWebPageInfo> => {
    const url = `/Request_WebPage_Info?sessionID=${token}&webPageEntityID=${webPageId}`
    const res: any = await this.getData(url);
    return this.checkError(res, null);
  }

  requestNewAlarm = async (token: tokenType): CayugaResponseType<IAlarm> => {
    const url = `/Request_Alarm?sessionID=${token}`;
    const res: any = await this.getData(url);
    return this.checkError(res, null);
  }

  requestAlarmScenarioList = async (token: tokenType): CayugaResponseType<IAlarmScenarios> => {
    const url = `/Request_Alarm_Scenario_List?sessionID=${token}`;
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:AlarmScenarioInfos');
  }

  requestButtonList = async (token: tokenType): CayugaResponseType<IButtonScenarios> => {
    const url = `/Request_Button_List?sessionID=${token}`;
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:Entities');
  }

  startButtonAction = async (token: tokenType, buttonID: string): CayugaResponseType<IErrorResponse> => {
    const url = `/Start_Button_Action?sessionID=${token}&buttonEntityID=${buttonID}`;
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:Entities');
  }

  startLiveStream = async (token: tokenType, cameraId: string, codec: string, fps: number, width: number, height: number): Promise<any> => {
    const url = `/Request_Live_RTSP?sessionID=${token}&cameraID=${cameraId}&codec=orginal`;
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:RtspURL');
  }

  getTimeLine = async (params: getTimeLineInterface): CayugaResponseType<IRequestArchiveRanges> => {
    const {token, camId} = params;
    const url = `/Request_Archive_Ranges?sessionID=${token}&cameraEntityID=${camId}`;
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:ArchiveRange')
  }

  requestVersionInfo = async (token: tokenType): CayugaResponseType<string> => {
    const url = `/Request_Version_Info?sessionID=${token}`;
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:Version');
  }

  disconnect = async (token: tokenType): CayugaResponseType<string> => {
    const url = `/Disconnect?sessionID=${token}`
    const res: any = await this.getData(url);
    return this.checkError(res, null);
  }
  confirmAlarm = async (token: tokenType, alarmID: string): CayugaResponseType<IBasicResponse> => {
    const url = `/Confirm_Alarm?sessionID=${token}&alarmID=${alarmID}`;
    const res: any = await this.getData(url);
    return this.checkError(res, null);
  }
  refuseAlarm = async (token: tokenType, alarmID: string): CayugaResponseType<IBasicResponse> => {
    const url = `/Refuse_Alarm?sessionID=${token}&alarmID=${alarmID}`
    const res: any = await this.getData(url);
    return this.checkError(res, null);
  }
  searchTriggeredAlarms = async (token: tokenType, startTime: number, endTime: number, alarmScenarioIDs: Array<string>, startPriority: number = -1, endPriority: number = -1): CayugaResponseType<ITriggeredAlarms> => {
    const url = `/Search_Triggered_Alarms?sessionID=${token}&startTime=${startTime - 1000}&endTime=${endTime + 1000}&startPriority=${startPriority}&endPriority=${endPriority}&alarmScenarioIDs=${alarmScenarioIDs.join(',')}`;
    const res = await this.getData(url);
    return this.checkError(res, 'a:TriggeredAlarmInfos');
  }
  getBookmarks = async (token: tokenType, camId: string, startTimestamp: number = -1, stopTimestamp: number = -1, keywords: string = ''): CayugaResponseType<IRequestBkmList> => {
    const url = `/Request_Bookmark_List?sessionID=${token}&cameraEntityID=${camId}&startTimestamp=${startTimestamp}&stopTimestamp=${stopTimestamp}&keywords=${keywords}`;
    const res: any = await this.getData(url);
    return this.checkError(res, 'a:Entities');
  }
  setBookmark = async (params: createCayugaBookmarkType): CayugaResponseType<IErrorResponse> => {
    const {token, id, bookmarkID = -1, timestamp, data} = params;
    const {name, description} = data;
    const url = `/Set_Bookmark?sessionID=${token}&cameraEntityID=${id}&bookmarkID=${bookmarkID}&timestamp=${timestamp}&name=${name}&description=${description}`;
    const res = await this.getData(url);
    return this.checkError(res, null);
  }
  deleteBookmark = async (token: tokenType, bookmarkID: string): CayugaResponseType<IErrorResponse> => {
    const url = `/Delete_Bookmark?sessionID=${token}&bookmarkID=${bookmarkID}`;
    const res = await this.getData(url);
    return this.checkError(res, null);
  }

  checkError<T>(data: any, dataName: string | null): ICheckError<T> {
    return data['a:ErrorCode'] === '0'
      ? {
        error: false,
        data: dataName ? data[dataName] : data
      }
      : {
        error: true,
        data: data['a:ErrorDescription']
      };
  }

  generateId(): string {
    const genId = () => {
      let id = Math.random() * 1000 + '';
      if (this.cancelTokens[id]) id = genId();
      return id
    };

    return genId();
  };

  cancelAllRequests(): void {
    Object.keys(this.cancelTokens)
      .map((id: any) => this.cancelRequest(id));
  }

  cancelRequest(id: string): void {
    if (!this.cancelTokens[id]) return;
    this.cancelTokens[id].cancel(`Token ${id} cancelled`);
    this.clearId(id);
  }

  clearId(id: string): void {
    if (this.cancelTokens[id]) delete this.cancelTokens[id]
  }
}

CayugaServiceData.prototype.TOKEN = '';

const cayugaServiceData: CayugaServiceDataInterface = new CayugaServiceData();

window.axios = axios;
window.cayugaServiceData = cayugaServiceData;
// typeof (CONFIG) !== 'undefined' ? 


export default cayugaServiceData